
<script>
    import { sidebarStatus } from '@/Layouts/Main'
</script>

<nav id="sidebar" class="bg-blue p-14 md:p-20 text-white font-bold text-2xl md:text-4xl flex" class:active={$sidebarStatus === 'active'}>
    <div class="absolute flex md:hidden btn-close">
      <button on:click={() => {sidebarStatus.update(s => s == 'active' ? '' : 'active')}} class="btn-close-menu rounded-full bg-black bg-opacity-10 text-white font-semibold ">
        <i class="fa-light fa-xmark"></i>
      </button>
    </div>
    <ul class="list-none self-center leading-relaxed">

        <li class="my-3"><a href="https://www.mur-partners.com/conocenos/" class="link-underline">Conócenos</a></li>
        <li class="my-3"><a href="https://www.mur-partners.com/empresas/" class="link-underline">Servicios</a></li>
        <li class="my-3"><a href="https://www.mur-partners.com/candidatos/" class="link-underline">Candidatos/as</a></li>
        <li class="my-3"><a href="https://www.mur-partners.com/areas-especializadas/" class="link-underline">Sectores y Áreas</a></li>
        <li class="my-3"><a href="https://www.mur-partners.com/actualidad/" class="link-underline">Actualidad</a></li>
        <li class="my-3"><a href="https://ofertas.mur-partners.com" class="link-underline">Ofertas</a></li>
        <li class="my-3"><a href="https://www.mur-partners.com/contacto/" class="link-underline">Contacto</a></li>

    </ul>


</nav>
